<template>
  <b-container class="booking-failure">
    <b-row>
      <b-col cols="12" lg="2" class="text-center">
        <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
      </b-col>
      <b-col cols="12" lg="10">
        <label class="confirm-message-label" v-html="$t('booking_failure.failure_msg')"
               v-if="!paymentRecord || paymentRecord.payment_method !== 'cyber_source'"></label>
        <label class="confirm-message-label"
               v-if="paymentRecord && paymentRecord.payment_method === 'cyber_source'">
          {{ paymentRecord.cyber_source_payment_records[0].reason_code === '150' ? 'Transaction unsuccessful. Please try again' : 'Transaction rejected. Please contact your bank' }}
        </label>
      </b-col>
    </b-row>
    <b-row v-if="paymentRecord">
      <b-col>
        <label>{{ $t('booking_failure.request_ref_no') }}: {{ paymentRecord.payment_method === 'cyber_source' ? paymentRecord.cyber_source_payment_records[0].request_ref_no : paymentRecord.union_pay_payment_records[0].order_id }}</label>
      </b-col>
    </b-row>
    <hr>
    <b-row class="mt-3">
      <b-col>
        <v-btn color="primary"
               :to="{name: 'my-account', query: {t: 3}}">
          {{ $t('finish') }}
        </v-btn>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faChevronCircleLeft} from '@fortawesome/free-solid-svg-icons'
import {computed, onMounted, ref} from "@vue/composition-api";
import {BOOKING_STATUS_LABEL} from "@/constants";

library.add(faChevronCircleLeft);

export default {
  name: 'GymPassFailure',
  setup(props, {root}) {
    const facilityType = ref(null);
    const getFacilityType = function () {
      root.$callAPI('aafb/gym_subscription/get_facility_type/', {}, function (response) {
        facilityType.value = response.body.facility_type;
      });
    };

    const subscription = ref(null);
    const subscriptionStatus = computed(() => {
      return subscription.value ? root.$t(BOOKING_STATUS_LABEL[subscription.value.status]) : '';
    })
    const getSubscription = function () {
      root.$callAPI('aafb/gym_subscription/', {subscription_id: root.$route.params.subscriptionId}, function (response) {
        subscription.value = response.body.subscription;
      })
    };

    const paymentRecord = ref(null);
    const getPaymentRecord = function () {
      this.$callAPI('aafb/payment_record/', {booking_record_id: root.$route.params.subscriptionId}, function (response) {
        paymentRecord.value = response.body.record;
      });
    }

    onMounted(() => {
      getFacilityType();
      getSubscription();
      getPaymentRecord();
    });

    return {
      facilityType,
      subscription,
      subscriptionStatus,
      paymentRecord,
    }
  },
}
</script>

<style lang="less">
.booking-failure {
  padding: 30px;

  .fa-exclamation-triangle {
    font-size: 5em;
  }

  .confirm-message-label {
    text-align: left;
    line-height: 2.5em;
    font-size: 2em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 2.5em;
  }

  .countdown {
    text-align: right;
    font-size: 2.5em;
  }

  .booking-pfailure-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;
    font-size: 1.2em;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }

  .accept-tnc {
    text-align: left;
    padding: 30px;
    font-size: 1.2em;
  }
}

.countdown {
  text-align: right;
}
</style>
